const DEFAULT_ERROR_MESSAGE = 'commonForms.errors.genericError'

const parseInvalidRecord = (codes: string[]): string[] => {
  const translationKeys = codes
    .map(code => `commonForms.apiErrors.${code.replace('.', '_')}`)
    .filter(Boolean)

  if (
    translationKeys?.some(m => m === DEFAULT_ERROR_MESSAGE) &&
    translationKeys?.some(m => m !== DEFAULT_ERROR_MESSAGE)
  ) {
    return translationKeys?.filter(m => m !== DEFAULT_ERROR_MESSAGE)
  }

  return translationKeys
}

const parseForbiddenError = ({ subject = '' }): string[] =>
  subject
    ? [`commonForms.apiErrors.notAuthorized.${subject.replace(/\.|[ ]/, '_')}`]
    : ['commonForms.errors.notAuthorized']

export const parseError = error => {
  if (!error) {
    return []
  }

  switch (error.type) {
    case 'custom_error':
    case 'unauthorized':
    case 'invalid_record':
      return parseInvalidRecord(error?.codes || [])
    case 'not_found':
      return ['commonForms.errors.resourceNotFound']
    case 'forbidden_action':
      return parseForbiddenError(error || {})
    case 'required':
      return ['commonForms.errors.checkRequiredField']
    case 'unknown_error':
    default:
      return [DEFAULT_ERROR_MESSAGE]
  }
}
